/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Billing_CheckoutInputs */



/**
* | output |
* | --- |
* | "Opened a checkout" |
*
* @param {Activity_Billing_CheckoutInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const activity_billing_checkout = /** @type {((inputs?: Activity_Billing_CheckoutInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Billing_CheckoutInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открыта страница оплаты")
	return /** @type {LocalizedString} */ ("Opened a checkout")
});